import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "qb_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

export const api = axios.create({ baseURL: API, withCredentials: true });
api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fetcher = (url) => api.get(url).then((r) => r.data);

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d.errors) return Array.isArray(d.errors) ? d.errors.join(", ") : String(d.errors);
  if (typeof d.msg === "string") return d.msg;
  return JSON.stringify(d);
}

export const fmt = (n, d = 2) => (n == null || Number.isNaN(Number(n)) ? "—" : Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d }));
export const fmtPx = (n) => (n == null ? "—" : Number(n) >= 1000 ? fmt(n, 2) : Number(n) >= 1 ? fmt(n, 3) : fmt(n, 5));
export const pct = (n, d = 2) => (n == null ? "—" : `${Number(n) >= 0 ? "+" : ""}${fmt(n, d)}%`);
export const signed = (n, d = 2) => (n == null ? "—" : `${Number(n) >= 0 ? "+" : ""}${fmt(n, d)}`);
export const ago = (iso) => {
  if (!iso) return "—";
  const s = Math.max(0, (Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return `${Math.floor(s)}s ago`;
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};
const QUOTES = ["USDT", "USDC", "FDUSD", "BTC", "ETH"];
export const splitSym = (s) => { const q = QUOTES.find((x) => s?.endsWith(x) && s.length > x.length); return q ? [s.slice(0, -q.length), q] : [s || "", "USDT"]; };
export const baseOf = (s) => splitSym(s)[0];
export const pairLabel = (s) => { const [b, q] = splitSym(s); return q === "USDT" ? b : `${b}/${q}`; };
export const tsFmt = (iso) => (iso ? new Date(iso).toLocaleString("en-GB", { hour12: false }) : "—");
